/**
 * Length caps for the attribution strings a form sends. Shared by the client
 * (which trims before posting) and the server schemas (which truncate rather
 * than reject), so tracking data can never be the reason a lead is lost.
 * A paid click URL with gclid, gbraid and utm params easily passes 500 chars.
 */
export const TRACKING_LIMITS = {
  /** pageUri, referrer, landingReferrer. */
  url: 500,
  /** The first-touch landing URL keeps more of its query string. */
  landingUri: 1_000,
  gclid: 200,
} as const;

/** Cut a tracking string to `max` chars; absent stays absent. */
export function truncateTracking(value: string | undefined, max: number): string | undefined {
  return value === undefined ? undefined : value.slice(0, max);
}
